@import '../../scss/mixin';

.stop {
  @include btn();
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--llm-color-base-900);
  color: var(--llm-color-neutral-100);

  svg {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 2;
  }

  &:disabled,
  &[aria-disabled=true] {
    pointer-events: none;

    svg {
      opacity: 0.4;
    }
  }
}
